import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl text-primary-700 font-bold" }, "Japan Standard Health Checkup", -1)
const _hoisted_2 = { class: "bg-white rounded-lg mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold lg:mb-5 px-5 pt-5" }, "Schedule Logs", -1)
const _hoisted_4 = {
  key: 0,
  class: "space-y-4 divide-y divide-gray-40 lg:divide-y-0"
}
const _hoisted_5 = { class: "w-full lg:w-[150px]" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "w-full lg:w-[calc(100%-190px)]" }
const _hoisted_8 = { class: "text-[#323232]" }
const _hoisted_9 = { class: "text-[#323232]" }
const _hoisted_10 = {
  key: 1,
  class: "p-5"
}
const _hoisted_11 = { class: "flex items-center space-x-2 font-bold text-[#23A2B4] cursor-pointer" }

import PortalLayout from '@/layouts/PortalLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import { ChevronLeftIcon } from '@heroicons/vue/24/outline';
import { format } from 'date-fns';

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import patient from "@/classes/UserData";

interface scheduleLog {
    new_booking_date: string | Date,
    new_booking_start_time: string,
    new_booking_end_time: string,
    created_date: string | Date,
    description: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();

const loader = ref(false);
const showError = ref(false);
const errorMsg = ref();

const booking_type = ref(route.query.booking_type);
const booking_id_of_coporate_booking = ref(route.query.booking_id_of_coporate_booking as unknown as string);
const bookingId = ref(route.params.bookingId as unknown as string);
const scheduleLogs = ref<scheduleLog[]>([]);

const formatRescheduledDateText = (scheduleLog: scheduleLog) => {
    let textDisplay = "N/A";
    
    if(scheduleLog.new_booking_start_time && scheduleLog.new_booking_end_time) {
        textDisplay = `This appointment has been rescheduled to ${formatDate(scheduleLog.new_booking_date)} at ${formatTime(scheduleLog.new_booking_start_time)} - ${formatTime(scheduleLog.new_booking_end_time)} by the Admin.`;
    } else {
        textDisplay = `This appointment has been rescheduled to ${formatDate(scheduleLog.new_booking_date)} by the Admin.`;
    }

    return textDisplay;
}

const formatDate = (date: string | Date, longFormat = true) => {
    if(date) {
        if(longFormat) {
            return format(new Date(date), 'LLLL dd, yyyy');
        } else {
            return format(new Date(date), 'LLL dd, yyyy');
        }
    }
    return 'TBA';
}

const formatTime = (time : string) => {
    return time ? format(new Date(time), 'h:mm a') : 'TBA';
}

const returnToPage = () => {
    if(booking_type.value == 'Individual') {
        window.location.assign(`/appointment/show/${bookingId.value}`);
    } else {
        window.location.assign(`/appointment/show/${booking_id_of_coporate_booking.value}`);
    }
}

const fetchScheduleLogs = () => {
    loader.value = true
    
    patient.getAppointmentScheduleLogs(booking_type.value, bookingId.value)
        .then((result: any) => {
            loader.value = false;

            if(result.data.response.length > 0) {
                scheduleLogs.value = result.data.response;
                
                if(result.data.response.result_status == 500) {
                    showError.value = true;
                    errorMsg.value = "Something went wrong. Please try again later";
                }
            }
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted(() => { fetchScheduleLogs(); })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { defaultTitle: false }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (scheduleLogs.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleLogs.value, (scheduleLog, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex flex-wrap lg:space-x-10 p-5 lg:pt-0"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(formatDate(scheduleLog.created_date, false)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(formatRescheduledDateText(scheduleLog)), 1),
                    _createElementVNode("p", _hoisted_9, "Reason: " + _toDisplayString(scheduleLog.description ?? "N/A"), 1)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, " This appointment has not been rescheduled. "))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(ChevronLeftIcon), { class: "w-5 h-5" }),
        _createElementVNode("p", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (returnToPage()))
        }, "Return to Appointment Information")
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})